import { useCallback, useContext } from "react";

import { useParams } from "react-router-dom";

import RelatedTestsSection from "@/components/reports/RelatedTestsSection";
import { REPORT_RELATED_TESTS_QUERY } from "../../graphql/queries";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_ORDER_URL, CMP_PATIENTS_TEST_RESULT_URL, getCmpUrl } from "@/core/urls";
import { ViewerContext } from "@/tpo/Viewer";

export default function PatientRelatedTestsSection({ report }) {
  const { userId } = useContext(ViewerContext);
  const { organisation, organisationId } = useOrganisationContext();
  const { patientId } = useParams();

  const getOrderUrl = useCallback(
    orderId =>
      getCmpUrl(CMP_ORDER_URL, {
        organisationId: organisation.hashId,
        orderId,
        patientId
      }),
    [organisation, patientId]
  );

  const getTestResultUrl = useCallback(
    userTestId =>
      getCmpUrl(CMP_PATIENTS_TEST_RESULT_URL, {
        organisationId: organisation.hashId,
        userTestId,
        patientId
      }),
    [organisation, patientId]
  );

  return (
    <RelatedTestsSection
      query={REPORT_RELATED_TESTS_QUERY}
      variables={{
        organisationId,
        userId,
        report: report?.slug,
        allTests: true,
        includeUnapproved: true
      }}
      skip={!organisationId || !userId || !report?.slug}
      getOrderUrl={getOrderUrl}
      getTestResultUrl={getTestResultUrl}
    />
  );
}
